import { z } from 'zod';
import { paginationQuerySchema } from '../common/pagination.js';
export const userStatusSchema = z.enum(['ACTIVE', 'INACTIVE']);
export const createUserSchema = z.object({
    employeeId: z.string().min(1).optional(),
    nameAr: z.string().trim().min(1, 'nameAr is required').optional(),
    nameEn: z.string().trim().min(1).optional(),
    username: z.string().trim().min(1, 'username is required'),
    email: z.string().trim().email().optional(),
    phone: z.string().trim().optional(),
    groupId: z.string().min(1, 'groupId is required'),
    branchIds: z.array(z.string().min(1)).min(1, 'at least one branch is required'),
});
export const updateUserSchema = z.object({
    nameAr: z.string().trim().min(1).optional(),
    nameEn: z.string().trim().min(1).optional(),
    email: z.string().trim().email().optional(),
    phone: z.string().trim().optional(),
    groupId: z.string().min(1).optional(),
    branchIds: z.array(z.string().min(1)).min(1).optional(),
});
export const changeUserStatusSchema = z.object({ status: userStatusSchema });
export const userListQuerySchema = paginationQuerySchema.extend({
    status: userStatusSchema.optional(),
    groupId: z.string().optional(),
});
export const employeeLookupQuerySchema = z.object({ username: z.string().trim().min(1) });
//# sourceMappingURL=user.contract.js.map